import { render, staticRenderFns } from "./WordpressApiKey.vue?vue&type=template&id=bf439552&scoped=true&"
import script from "./WordpressApiKey.vue?vue&type=script&lang=js&"
export * from "./WordpressApiKey.vue?vue&type=script&lang=js&"
import style0 from "./WordpressApiKey.vue?vue&type=style&index=0&id=bf439552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf439552",
  null
  
)

export default component.exports